export default __webpack_public_path__ + "static/contact-bg-06f5d3b8d21c4cb84b38ad398b81b4a5.png";